import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { EmailListComponent } from './email-list/email-list.component';
import { ProjectResultsComponent } from './project-results/project-results.component';
import { UserResultsComponent } from './user-results/user-results.component';
import { ReportsRoutingModule } from './reports-routing.module';
import { MatSelectModule } from '@angular/material/select';
import { AgGridModule } from '@ag-grid-community/angular';



@NgModule({
  declarations: [
    EmailListComponent,
    ProjectResultsComponent,
    UserResultsComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReportsRoutingModule,
    MatSelectModule,
    AgGridModule
  ],
  exports: [
    EmailListComponent
  ]
})
export class ReportsModule { }
